import { gql } from '@apollo/client';

const query = gql`
  query searchSeoCategory($params: JSONObject) {
    searchSeoCategory(params: $params)
  }
`;

module.exports = query;
